import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  viewBox: "0 0 14 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.757 11.905c-.474 2.478-1.05 4.854-2.762 6.095-.527-3.745.775-6.558 1.38-9.544-1.031-1.737.125-5.23 2.3-4.37 2.678 1.059-2.318 6.455 1.036 7.13 3.5.703 4.93-6.075 2.759-8.279-3.137-3.184-9.131-.075-8.393 4.484.179 1.114 1.33 1.452.46 2.99C.529 9.966-.071 8.382.007 6.271.13 2.815 3.11.396 6.1.061c3.78-.424 7.33 1.388 7.82 4.944.552 4.015-1.706 8.364-5.75 8.05-1.096-.085-1.555-.628-2.413-1.15Z" }, null, -1)
  ])))
}
export default { render: render }